import React from 'react'
import { Link } from 'found'

export default function Brand({ link, image }) {

    return (
        <Link to={link} className="logo w-nav-brand" style={{position:'absolute'}}>
            <img alt="logo" src={image} height={48} className="image-21" />
        </Link>
    )
}
